import { GENERIC_ANALYZABLE_PACKAGING_TYPE_IDS, GENERIC_PACKAGING_TYPE_ID, GENERIC_RIGID_PACKAGING_TYPE_ID } from '../../../../navigation/services/packaging-unit-type-service';
import { COLOR_THEME_DARK } from './../../../../navigation/services/color-theme-service';
import { ComponentHandler } from 'src/app/services/component-services/component-handler';
import { ComponentApiService } from '../../../../data-transfer/services/component-api-service';
import { ComponentNavigationService } from 'src/app/navigation/services/navigation-services/component-navigation-service';
import { ComponentTypeService } from 'src/app/navigation/services/component-type-service';
import { PackagingUnitTypeService } from 'src/app/navigation/services/packaging-unit-type-service';
import { DictionaryHandler } from './../../../../model/dictionary';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import { AuthService } from 'src/app/services/auth-service';
import { GtinCheckService } from 'src/app/services/component-services/gtin-check-service';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ColorThemeService } from 'src/app/navigation/services/color-theme-service';
import { ComponentCreateUpdateParentComponent } from './../common/component-create-update-parent/component-create-update-parent.component';
import { ComponentCanDeactivate } from 'src/app/services/unsaved-changes-guard';
import { PackagingComponentTypesEnum } from 'src/app/model/packaging-component-types-enum';
import { Component, HostListener, OnInit } from '@angular/core';
import { VersionDto } from 'src/app/data-transfer/entities/version-dto';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { MainBodyDto } from 'src/app/data-transfer/entities/component-entities/main-body-dto';
import { DataExchangeRequestApiService } from 'src/app/data-transfer/services/data-exchange-request-api-service';
import { PathResolveService } from 'src/app/services/path-resolve.service';
import { DirectoryApiService } from 'src/app/data-transfer/services/directory-api-service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-create-update-main-body',
  templateUrl: './create-update-main-body.component.html',
  styleUrls: ['./create-update-main-body.component.scss']
})
export class CreateUpdateMainBodyComponent extends ComponentCreateUpdateParentComponent
  implements OnInit, ComponentCanDeactivate {

  mainBody!: MainBodyDto;

  constructor(
    protected componentHandler: ComponentHandler,
    protected dialog: MatDialog,
    protected spinner: NgxSpinnerService,
    protected componentApiService: ComponentApiService,
    protected navigationService: ComponentNavigationService,
    protected componentTypeService: ComponentTypeService,
    protected packagingUnitTypeService: PackagingUnitTypeService,
    protected dictionaryHandler: DictionaryHandler,
    protected fileApiService: FileApiService,
    protected authService: AuthService,
    protected gtinCheckService: GtinCheckService,
    protected dataExchangeApiService: DataExchangeRequestApiService,
    protected route: ActivatedRoute,
    protected router: Router,
    protected directoryApiService: DirectoryApiService,
    protected translocoService: TranslocoService,
    private formBuilder: FormBuilder,
    private colorThemeService: ColorThemeService,
  ) {
    super(componentHandler, dialog, spinner, componentApiService, navigationService,
      componentTypeService, dictionaryHandler, fileApiService, authService, gtinCheckService,
      dataExchangeApiService, route, router, directoryApiService, translocoService);
  }

  ngOnInit(): void {
    this.callerId = PackagingComponentTypesEnum.MainBody;
    this.componentType = this.componentTypeService.getComponentTypeDtoByName('main body');
    this.componentSubtypes = this.componentHandler.getComponentSubtypesSelection(this.callerId);

    this.routeDataSubscription = this.route.data.subscribe(data => {
      if (data.component) {
        this.mainBody = data.component;
        this.historyVersions = [{
          id: data.component.id,
          versionNumber: data.component.version,
          versionName: data.component.versionName,
          creationTimestamp: data.component.creationTimestamp,
          isCurrentVersion: data.component.isCurrentVersion,
          packagingComponentCategoryId: this.callerId
        }];
        this.currentDirectoryId = data.component.directoryId;
        if (this.form) {
          window.location.reload();
          super.initComponent(this.mainBody, this.route);
        }
      } else if (data.dataExchangeRequest) {
        this.mainBody = data.dataExchangeRequest.component;
        this.subRequestInfo = data.dataExchangeRequest.subRequestInfo;
        this.historyVersions = [{
          id: data.dataExchangeRequest.component.id,
          versionNumber: data.dataExchangeRequest.component.version,
          versionName: data.dataExchangeRequest.component.versionName,
          creationTimestamp: data.dataExchangeRequest.component.creationTimestamp,
          isCurrentVersion: data.dataExchangeRequest.component.isCurrentVersion,
          packagingComponentCategoryId: this.callerId
        }];
        this.currentDirectoryId = data.dataExchangeRequest.component.directoryId;
        if (this.form) {
          window.location.reload();
          super.initComponent(this.mainBody, this.route);
        }
      } else {
        this.mainBody = new MainBodyDto();
        this.mainBody.images = [];
        this.mainBody.certificates = [];
        this.mainBody.documents = [];
      }

      this.isInternallyTracked = data.dataExchangeRequest?.isInternallyTracked ?? data.isInternallyTracked;

      if (data.permissions) {
        this.permissions = data.permissions;
      }
      if (data.isDataExchangeSubRequest) {
        this.isDataExchangeSubRequest = true;
        if (!data.permissions) {
          super.fetchComponentPermissions(this.mainBody.id);
        }
      }
      if (data.isInOngoingDataExchange) {
        this.isInOngoingDataExchange = data.isInOngoingDataExchange;
        if (this.isInOngoingDataExchange.length > 0 && this.mainBody.isCurrentVersion) {
          super.navigateToFirstOngoingExchange(this.mainBody.id);
          return;
        }
      }
    });
    this.routeParamsSubscription = this.route.params.subscribe(params => {
      if (this.mainBody.id == null) {
        if (params.packagingType) {
          this.mainBody.packagingComponentSubtypeId = this.packagingUnitTypeService.getPackagingUnitTypeId(params.packagingType);
        } else {
          this.mainBody.packagingComponentSubtypeId = GENERIC_PACKAGING_TYPE_ID;
        }
      }
    });

    super.initComponent(this.mainBody, this.route);

    const mainBodyComponent = this.componentHandler.components[this.callerId];
    this.form = mainBodyComponent.createBaseForm(this.mainBody, this.formBuilder, this.componentSubtypes, this.isTracked);
    this.form = this.formBuilder.group({
      ...this.form.controls,
      distributionCountries: [this.mainBody.distributionCountries],
      printingCoverage: [this.mainBody.printingCoverage != null ? this.mainBody.printingCoverage * 100 : null,
      [Validators.min(0), Validators.max(100)]],
      volume: [{ value: this.mainBody.packagingVolume, disabled: this.isTracked }, Validators.min(0.001)]
    });
    this.checkSubtypeSetRigidField(this.mainBody.packagingComponentSubtypeId);
    this.form.controls.packagingComponentSubtypeId.valueChanges.subscribe(newType => {
      this.checkSubtypeSetRigidField(newType);
    });
    this.form.controls.totalWeight.disable();
    super.initGtinCheck();

    this.setUpLockAndHeartbeat(this.mainBody);
    this.disableFormIfRequired();

    this.themeSubscription = this.colorThemeService.colorThemeSubject.subscribe((nextValue) => {
      this.isDarkTheme = nextValue === COLOR_THEME_DARK;
      this.imageSource = this.packagingUnitTypeService.getPackagingUnitTypeImage(this.mainBody.packagingComponentSubtypeId);
    });

    this.valueChangeSubscription = this.form.controls.packagingComponentSubtypeId.valueChanges.subscribe(newTypeId => {
      this.imageSource = this.packagingUnitTypeService.getPackagingUnitTypeImage(newTypeId);
      this.mainBody.packagingComponentSubtypeId = newTypeId;
    });
  }

  private checkSubtypeSetRigidField(subtypeId: number) {
    if (GENERIC_ANALYZABLE_PACKAGING_TYPE_IDS.includes(subtypeId)) {
      this.form.controls.isRigidComponent.patchValue(subtypeId === GENERIC_RIGID_PACKAGING_TYPE_ID ? true : false);
      this.form.controls.isRigidComponent.disable();
    } else {
      this.form.controls.isRigidComponent.enable();
    }
  }

  async onComponentSubmit(materialEdited: boolean) {
    this.materialEdited = materialEdited;
    this.form.markAllAsTouched();
    const mainBodyComponent = this.componentHandler.components[this.callerId];
    this.mainBody = mainBodyComponent.getSingleComponentFromForm(this.form.getRawValue(), false, this.mainBody) as MainBodyDto;
    // this.mainBody.packagingComponentSubtypeId = this.form.controls.packagingComponentSubtypeId.value;

    super.onSubmit(this.mainBody);
  }

  async onFinishSubRequest(materialEdited: boolean) {
    if (!super.isFormValidForSubRequest()) { return; }
    this.materialEdited = materialEdited;
    this.form.markAllAsTouched();
    const mainBodyComponent = this.componentHandler.components[this.callerId];
    this.mainBody = mainBodyComponent.getSingleComponentFromForm(this.form.getRawValue(), false, this.mainBody) as MainBodyDto;
    const subRequestId = +this.route.snapshot.params['id'];
    super.setDataAndUpdateAsSubRequest(
      this.mainBody,
      subRequestId,
      (id, dto, submit, stayOnPage) => this.dataExchangeApiService.updateSubRequestMainBody(id, dto, submit, stayOnPage),
      () => this.router.navigateByUrl('/' + PathResolveService.getDataExchangeRequestsPath(true) + '?tab=1')
    );
  }

  changeMainBodyVersionName(event: { historyVersion: VersionDto, newName: string }) {
    super.changeVersionName(event.historyVersion, event.newName, this.mainBody);
  }

  async releaseComponent() {
    super.releaseComponent(this.mainBody);
  }

  @HostListener('window:beforeunload')
  canDeactivate(): boolean {
    return (this.form.pristine && !this.filesEdited) || this.isPreview || this.isUserValidator || this.isUserAdmin || this.isHistory;
  }
}
